
const __default__ = {
  props: {
    hoverable: {
      type: Boolean,
      default: true
    },
    hover: {
      type: Boolean,
      default: false
    },
    duration: {
      type: String,
      default: '2s'
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    transparent: {
      type: Boolean,
      default: false
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "359f84aa-duration": (_ctx.duration)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__